<template>
  <el-table
    :data="models"
    :stripe="true"
    size="small"
  >
    <el-table-column
      label="Type"
      :formatter="row => $_.get(row, 'type.name') || '-'"
    />
    <el-table-column
      label="Name"
      :formatter="row => $_.get(row, 'name') || '-'"
    />
    <el-table-column
      label="Description"
      :formatter="row => $_.get(row, 'description') || '-'"
    />
    <el-table-column
      label="Manufacturer"
      :formatter="row => $_.get(row, 'asset_manufacturer.name') || '-'"
    />
    <el-table-column
      label="Created at"
      prop="created_at"
      :formatter="(row, col, cellValue) => cellValue ? $moment(cellValue).format('lll') : '-'"
    />
    <el-table-column
      label="Update at"
      prop="updated_at"
      :formatter="(row, col, cellValue) => cellValue ? $moment(cellValue).format('lll') : '-'"
    />
    <el-table-column
      label="Actions"
      align="right"
    >
      <template slot-scope="props">
        <slot
          name="action"
          :models="props.row"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    models: {
      type: Array,
      required: true
    }
  }
}
</script>
